"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GetTranslationProductName;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

function GetTranslationProductName() {
  var runtimeConfig = (0, _runtimeConfigHelper.getRuntimeConfig)();

  if (runtimeConfig._translationProductName) {
    return runtimeConfig._translationProductName;
  } // REFACTOR: get translation product name from config.js, can be used inn translation-product-helper, and localization-updater-helper.


  switch (runtimeConfig._app) {
    case 'app-store-editor':
    case 'app-store-shop':
    case 'app-designer':
    case 'app-site-runtime':
      return (0, _camelCase["default"])(runtimeConfig._app);

    default:
      return 'ControlPanel';
  }
}